import * as React from 'react'
import { IDriverSearchObject, IUpdateDriver } from '../../types'
import EntityHeader from '../ui/entity/EntityHeader'
import EntityHeaderTitle from '../ui/entity/EntityHeaderTitle'
import EntityTabBar from '../ui/entity/EntityTabBar'
import EntityTabBarItem from '../ui/entity/EntityTabBarItem'
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom'
import PersonalInfoForm from './editdriver/personalinfo/PersonalInfoForm'
import EditDriverProducts from '../../containers/drivers/EditDriverProducts'
import EntityErrorMessage from '../ui/entity/EntityErrorMessage'
import UIMessages from '../../utils/ui-messages'
import PreloaderCircle from '../ui/PreloaderCircle'
import history from 'src/history'
import DriverEditSchedule from 'src/containers/drivers/DriverEditSchedule'
import { driversService, IDriverAddress, IDriverUpdateAddressPayload } from 'src/services/Drivers'

interface IDriverEditProps {
  driverId: string
  routeProps: RouteComponentProps<any>
  loading: boolean
  loadingError: string
  getDriverInfo: (driverId: string) => void
  updateDriverInfo: (driverInfo: IUpdateDriver) => Promise<any>
  driver: IDriverSearchObject
  history: any
  location: any
  match: any
}
interface IDriverEditState {
  // Added a local state for future use
  loading: boolean
  inProductsTab: boolean
}

class DriverEdit extends React.Component<IDriverEditProps, IDriverEditState> {
  public state: IDriverEditState = {
    loading: true,
    inProductsTab: false
  }

  public async componentDidMount() {
    await this.props.getDriverInfo(this.props.driverId)
    this.setState({
      loading: false
    })
  }

  public render() {
    if (!this.props.driver) {
      return null
    }

    const operator = this.props.driver

    const styles = {
      CirclePreLoader: {
        display: 'flex',
        paddingTop: '5px',
        flex: 1,
        justifyContent: 'center',
        alignment: 'center',
        width: '100%'
      }
    }

    if (this.props.loading && !this.state.inProductsTab) {
      return (
        <div style={styles.CirclePreLoader}>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    return (
      <div className='border-top'>
        <EntityHeader>
          <EntityHeaderTitle>{`Edit ${operator.firstName} ${operator.lastName}`}</EntityHeaderTitle>
        </EntityHeader>

        <EntityTabBar>
          <TabLink to={`${this.props.routeProps.match.url}`} exact={true} label='Personal info' />
          <TabLink to={`${this.props.routeProps.match.url}/products`} label='products' />
          <TabLink to={`${this.props.routeProps.match.url}/schedule`} label='schedule' />
        </EntityTabBar>

        {this.props.loadingError && <EntityErrorMessage>{this.props.loadingError}</EntityErrorMessage>}

        <Switch>
          <Route path={`${this.props.routeProps.match.path}/products`} component={this.renderDriverProducts} />
          <Route path={`${this.props.routeProps.match.path}/schedule`} component={this.renderDriverSchedule} />
          <Route path={this.props.routeProps.match.path} render={this.renderInfoForm} />
        </Switch>
      </div>
    )
  }

  private renderInfoForm = () => {
    if (this.state.inProductsTab) {
      this.setState({ inProductsTab: false })
    }

    return (
      <PersonalInfoForm
        driver={this.props.driver}
        handleSubmit={this.handleDriverInfoSubmit}
        history={this.props.history}
        match={this.props.match}
        loading={this.props.loading}
        submitBtnText={UIMessages.common.update}
      />
    )
  }

  private renderDriverProducts = (props: RouteComponentProps<any>) => {
    if (!this.state.inProductsTab) {
      this.setState({ inProductsTab: true })
    }
    return <EditDriverProducts {...props} submitBtnText={UIMessages.common.update} />
  }

  private renderDriverSchedule = (props: RouteComponentProps<any>) => {
    if (!this.state.inProductsTab) {
      this.setState({ inProductsTab: true })
    }
    return <DriverEditSchedule operatorId={this.props.driver.id} />
  }

  private handleDriverInfoSubmit = async (driverInfo: IUpdateDriver) => {
    if (!this.props.driver) {
      return Promise.resolve()
    }

    return await this.props.updateDriverInfo(driverInfo).then(async () => {
      // Use Promise.resolve to create a resolved Promise for history.push
      return Promise.resolve(history.push(`/drivers/${this.props.driver.id}/details`))
    })
  }
}

const TabLink = ({ to, exact = false, label }: any) => {
  const children = ({ match }: any) => (
    <Link to={to}>
      <EntityTabBarItem active={!!match}>{label}</EntityTabBarItem>
    </Link>
  )
  return <Route path={to} exact={exact} children={children} />
}

export default DriverEdit



// WEBPACK FOOTER //
// ./src/components/drivers/DriverEdit.tsx